import { captureError } from '@smg-real-estate/browser-rum';

import { useFunnelApiStore } from '@/stores/funnelApi/useFunnelApiStore';
import { useInsertionsStore } from '@/stores/insertions/useInsertionsStore';

const handleErrorWithNotification = async (
  callback: (...args: any[]) => any,
  options: { keepLoadingState?: boolean; insertionId?: string } = {
    keepLoadingState: false,
    insertionId: undefined,
  },
): Promise<any> => {
  const funnelApiStore = useFunnelApiStore();

  try {
    funnelApiStore.setFunnelApiLoading();

    if (options.insertionId) {
      useInsertionsStore().apiCallInsertionId = options.insertionId;
    }

    const response = await callback();

    if (options.insertionId) {
      useInsertionsStore().apiCallInsertionId = undefined;
    }

    if (!options.keepLoadingState) {
      funnelApiStore.resetFunnelApiStates();
    }

    return response;
  } catch (e) {
    funnelApiStore.setFunnelApiError(e as Error);
    useInsertionsStore().apiCallInsertionId = undefined;

    captureError(e);
  }
};

export default handleErrorWithNotification;
